import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/chat` → `/chat/new` (parity with the former `app/(chat)/chat/page.tsx`). */
export const Route = createFileRoute('/_app/_chat/chat/')({
  beforeLoad: () => {
    throw redirect({ to: '/chat/new' });
  },
});
